import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from "react-i18next";
import './VisitorInfo.css';

const VisitorInfo = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get('https://streamsrvbac.n-tools.info/info-manage/visitors');
        if (response.data.success) {
          setStats(response.data.data);
        } else {
          setError(response.data.message || "Failed to load statistics.");
        }
      } catch (err) {
        setError("Could not connect to the server.");
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) return (
    <div className="visitor-loader">
      <div className="spinner"></div>
      <p>Loading Visitor Info...</p>
    </div>
  );

  if (error) return (
    <div className="visitor-error">
      <div className="error-icon">🚫</div>
      <h2>Error</h2>
      <p>{error}</p>
    </div>
  );

  return (
    <div className="visitor-info-container">
      {/* Page Header */}
      <header className="visitor-header">
        <h1>Visitor Analytics</h1>
        <p>Monitor daily visitors and system health metrics.</p>
      </header>

      {/* Summary Cards */}
      <div className="visitor-stats-grid">
        <div className="visitor-card">
          <div className="card-content">
            <span>Total Visits Today</span>
            <span className="card-value">{stats?.today_total_visits || 0}</span>
          </div>
          <div className="card-icon">👥</div>
        </div>
        <div className="visitor-card">
          <div className="card-content">
            <span>Server Status</span>
            <span className="card-value status-green">Healthy</span>
          </div>
          <div className="card-icon">✅</div>
        </div>
        <div className="visitor-card">
          <div className="card-content">
            <span>Log Parser</span>
            <span className="card-value status-purple">Active</span>
          </div>
          <div className="card-icon">📊</div>
        </div>
      </div>

      {/* Recent User Sessions */}
      <section className="visitor-table-section">
        <h2>Recent User Sessions</h2>
        <div className="table-wrapper">
          <table className="visitor-table">
            <thead>
              <tr>
                <th>User Name</th>
                <th>IP Address</th>
                <th>Login Time</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {stats?.user_sessions?.length ? stats.user_sessions.map((session, idx) => (
                <tr key={idx}>
                  <td>{session.username}</td>
                  <td>{session.ip_address}</td>
                  <td>{session.login_time}</td>
                  <td>
                    <span className={`status-pill ${session.duration === 'Active' ? 'active' : 'stable'}`}>
                      {session.duration}
                    </span>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan="4" className="no-data">No active sessions found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* Traffic History */}
      <section className="visitor-table-section">
        <div className="section-header">
          <h2>Traffic History (Last 10 Days)</h2>
          <button className="refresh-btn" onClick={() => window.location.reload()}>🔄 Refresh</button>
        </div>
        <div className="table-wrapper">
          <table className="visitor-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Visitor Count</th>
                <th>Trend</th>
              </tr>
            </thead>
            <tbody>
              {stats?.visit_history?.length ? stats.visit_history.map((day, idx) => (
                <tr key={idx}>
                  <td>{day.visit_date}</td>
                  <td>{day.visitor_count}</td>
                  <td><span className="status-pill stable">Stable</span></td>
                </tr>
              )) : (
                <tr><td colSpan="3" className="no-data">No data available.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default VisitorInfo;
